////////LIBRARY/////////
import { isUndefined } from 'lodash'
///////COMPONENTS///////
import { put, select, takeLatest } from 'redux-saga/effects'
import ActionsTypes from '../../constants/ActionsTypes'
import { globalLoadingActionCreators, errorManagerActionCreators, addItemCatalogActionCreators, toastSuccessActionCreators } from '../actions'
import * as R from '../../constants/Endpoint'
import { API_TOKEN } from '../../config/AxiosConfig'
import { selectIdsUser } from '../selectors/user'

const postBindCatalog = function* ({ payload }) {
	const bodyMsg = payload.filters
	const user = yield select(selectIdsUser)
	const apiCall = R.POST_BIND_CATALOG(payload.queryParams)

	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).post(apiCall, bodyMsg)

		yield put(addItemCatalogActionCreators.postBindCatalogSuccess(data.data))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(addItemCatalogActionCreators.postBindCatalogFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const putLinkCatalogItem = function* ({ payload }) {
	const user = yield select(selectIdsUser)
	const apiCall = R.PUT_LINK_CATALOG_ITEM(payload.idItem)
	const MsgParams = 'toast__itemCatalog__distributor__link_addItem'
	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).put(apiCall)

		yield put(addItemCatalogActionCreators.putLinkCatalogItemSuccess(data.data))
		yield put(toastSuccessActionCreators.hydrateToast(MsgParams))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(addItemCatalogActionCreators.putLinkCatalogItemFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const putUnlinkCatalogItem = function* ({ payload }) {
	const id = payload.idItem
	const user = yield select(selectIdsUser)
	const apiCall = R.PUT_UNLINK_CATALOG_ITEM(id)
	const MsgParams = 'toast__itemCatalog__distributor__link_removeItem'
	yield put(globalLoadingActionCreators.startLoading())
	try {
		const data = yield API_TOKEN(user.jwt).put(apiCall)

		yield put(addItemCatalogActionCreators.putUnlinkCatalogItemSuccess(data.data))
		if (isUndefined(data.data.errorCode)) {
			yield put(toastSuccessActionCreators.hydrateToast(MsgParams))
		}
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(addItemCatalogActionCreators.putUnlinkCatalogItemFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const sagas = function* () {
	yield takeLatest(ActionsTypes.POST_BIND_CATALOG, postBindCatalog)
	yield takeLatest(ActionsTypes.PUT_LINK_CATALOG_ITEM, putLinkCatalogItem)
	yield takeLatest(ActionsTypes.PUT_UNLINK_CATALOG_ITEM, putUnlinkCatalogItem)
}

export default sagas
